import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  input,
  Input,
  OnInit
} from '@angular/core';
import { Contact } from '@modules/contacts/shared/models/contact.model';
import { ContactType } from '@modules/contacts/shared/enums/contact-type.enum';
import { ContactController } from '@modules/contacts/shared/controllers/contact.controller';
import { Project } from '@modules/projects/shared/models/project.model';

@Component({
  selector: 'contact-name',
  templateUrl: './contact-name.component.html',
  styleUrls: ['./contact-name.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactNameComponent implements OnInit {
  ContactType = ContactType;

  protected svgConfig = {
    width: '10px',
    height: '10px'
  };

  private _contact: Contact;
  previewPermission: boolean = false;

  @Input() placement?: string = 'top';
  @Input() isProjectProfile: boolean = true;
  @Input() project: Project;

  defaultStyling = input<boolean>(false);

  @Input()
  set contact(contact: Contact) {
    this._contact = new Contact(contact);
    this.contactPreviewPermission();
    this.changes.detectChanges();
  }

  get contact() {
    return this._contact;
  }

  private changes = inject(ChangeDetectorRef);

  ngOnInit() {
    this.previewPermission = true;
  }

  preview() {
    const ctrl = new ContactController();
    ctrl.preview({ type: this.contact.type, id: this.contact.id });
  }

  contactPreviewPermission() {
    this.previewPermission = true;
  }
}
